import type { Answers, FilterType, Form } from "@/features/forms/models";
import { FILTER_TYPE } from "@/features/forms/models";
import { FIELD_TYPE } from "@/shared/models/legacy-constants";

export const evaluateFilterCondition = (
  filterType: FilterType,
  value1: string,
  value2: string,
) => {
  if (!value1) {
    return false;
  }

  switch (filterType) {
    case FILTER_TYPE.IS_LESS_THAN:
      return value1 < value2;
    case FILTER_TYPE.IS_LEES_THAN_OR_EQUAL_TO:
      return value1 <= value2;
    case FILTER_TYPE.IS_GREATER_THAN:
      return value1 > value2;
    case FILTER_TYPE.IS_GREATER_THAN_OR_EQUAL_TO:
      return value1 >= value2;
    case FILTER_TYPE.IS_EQUAL_TO:
      return value1 === value2;
    case FILTER_TYPE.IS_NOT_EQUAL_TO:
      return value1 !== value2;
    case FILTER_TYPE.INCLUDES:
      return value1.includes(value2);
    case FILTER_TYPE.CONTAINS:
      return value1.includes(value2);
    case FILTER_TYPE.DOES_NOT_INCLUDE:
      return !value1.includes(value2);
    case FILTER_TYPE.DOES_NOT_CONTAIN:
      return !value1.includes(value2);
    default:
      return false;
  }
};

export const filterHiddenConditionalAnswers = (
  answers: Answers,
  fields: Form["fields"],
): Answers => {
  const hiddenFieldIds = new Set(
    fields
      .filter((field) => {
        if (field.type === FIELD_TYPE.HIDDEN) {
          return !answers[field.id];
        }

        const condition = field.customModuleCondition;
        if (!condition) {
          return false;
        }

        const dependencyValue = String(
          answers[condition.conditionalCustomModuleId] ?? "",
        );
        return !evaluateFilterCondition(
          condition.filterType,
          dependencyValue,
          condition.valueToFilter,
        );
      })
      .map((field) => field.id),
  );

  return Object.fromEntries(
    Object.entries(answers).filter(([key]) => !hiddenFieldIds.has(key)),
  );
};
